// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5e755411","166":"56276bbd","213":"f5dcc168","250":"dc0d6a9d","383":"b26135c5","446":"258d51ce","453":"fcd5d657","467":"40371171","472":"020a1836","674":"f34e28ff","676":"f1e8d518","722":"072acaf3","842":"5c34d483"}[chunkId] + ".chunk.js";
};